$(document).ready(function () {
  // artical slider 
  function artical_slider_wpr() {
    var swiper = new Swiper(".artical_slider_wpr", {
      slidesPerView: 1,
      draggable: true,
      loop: false,
      breakpoints: {
        480: {
          slidesPerView: 2,
        }
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
  }
  artical_slider_wpr();
});